module.exports = __webpack_public_path__ + "static/media/muse_nyarubondo_mwogo_road7.75468b5f.jpg";